// extracted by mini-css-extract-plugin
module.exports = {"selectedValue":"useDataCollectionModel_selectedValue__YTuPJ","selectedName":"useDataCollectionModel_selectedName__1nYU_"};